import { useEffect, useState } from 'react';

/** Sous cette largeur, la semaine devient une liste de jours (390 px de téléphone). */
export const REQUETE_ECRAN_ETROIT = '(max-width: 767.98px)';

/** Vrai tant que l'écran est étroit ; faux hors navigateur ou sans `matchMedia`. */
export function useEcranEtroit(): boolean {
  const lire = (): boolean =>
    typeof window !== 'undefined' && typeof window.matchMedia === 'function'
      ? window.matchMedia(REQUETE_ECRAN_ETROIT).matches
      : false;
  const [etroit, setEtroit] = useState(lire);

  useEffect(() => {
    if (typeof window.matchMedia !== 'function') return;
    const requete = window.matchMedia(REQUETE_ECRAN_ETROIT);
    const suivre = (): void => setEtroit(requete.matches);
    suivre();
    requete.addEventListener('change', suivre);
    return () => requete.removeEventListener('change', suivre);
  }, []);

  return etroit;
}
